import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    current_header_step: "START",
};

export const personalAccidentFormSlice = createSlice({
    name: "personal_accident_form_slice",
    initialState,
    reducers: {
        setPersonalAccidentFormData: (state, action) => {
            let { form_name, data } = action.payload || {};
            state[form_name] = data;
        },
        clearPersonalAccidentFormData: (state, action) => {
            const { form_name } = action.payload || {};
            if (form_name) {
                state[form_name] = null;
            }
        },

        // header step
        setPersonalAccidentFormHeaderStep: (state, action) => {
            let stepType = action.payload;
            state.current_header_step = stepType;
        },

        clearNewPersonalAccidentFormData: () => initialState

    }
});

// SELECTORS
export const selectPersonalAccidentForm = (store) => store?.personalAccidentFormData;
export const selectPersonalAccidentFormHeaderStep = (store) => store?.personalAccidentFormData?.current_header_step;

// ACTIONS 
export const { 
    setPersonalAccidentFormData, 
    clearPersonalAccidentFormData, 
    setPersonalAccidentFormHeaderStep, 
    clearNewPersonalAccidentFormData 
} = personalAccidentFormSlice.actions;

export default personalAccidentFormSlice.reducer;